<template>
   <section id="player-section">
      <video 
         id="wipo-player"
         controls
         :poster="thumbnail"
         :key="videoMp4">
         <source 
            type="video/webm" 
            :src="videoWebM" /> 
         <source 
            type="video/mp4" 
            :src="videoMp4" />
         Your browser does not support the video tag.
      </video>
   </section>
</template>

<script>
import VueWindowSize from 'vue-window-size'

export default {
   props : {
      videoTitle : String,
      playerUrl : String,
      downloadLink : String,
      videoWebM : String,
      videoMp4 : String,
      thumbnail : String
   },
   data() {
      return {
         playerHeight : 300
      }
   },
   computed : {
      youtubeWidthResize() {
         let playerWidth = 0;

         if(window.innerWidth <= 425){
            playerWidth = window.innerWidth - 35
            return playerWidth;
         }
         if(window.innerWidth >= 768 &&  window.innerWidth <= 1024){
            playerWidth = window.innerWidth * .55
            return playerWidth;
         }
         return 760
      },
      youtubeHeightResize() {
         let playerWidth = 0;
         if(window.innerWidth <= 425){
            return 250
         }
         if(window.innerWidth >= 768 &&  window.innerWidth <= 1024){
            return 300;
         }
         return 435
      },
      loadDefaultHeight(){
         this.$emit('loadDefaultHeight', this.playerHeight)
      }
   },
   mounted(){
      this.playerHeight = this.youtubeHeightResize
      this.loadDefaultHeight
   }
}
</script>

<style scoped>
   video#wipo-player{
      width: 100%;
      height: 360px;
      background-color: #000;
   }

   @media screen and (max-width: 767px){
      video#wipo-player{
         width: 100%;
         height: auto;
         background-color: #192538;
      }  
   }
</style>



// WEBPACK FOOTER //
// src/components/Player.vue